export const clearCourseCache = (slug: string) => {
  const saveCoursesInStorage = (coursesList) => {
    sessionStorage?.setItem("courses_landing", JSON.stringify(coursesList));
  };

  const getCoursesFromStorage = () => {
    const storagedCourses = sessionStorage?.getItem("courses_landing");
    if (storagedCourses) return JSON.parse(storagedCourses);
    return [];
  };

  const storagedCourses = getCoursesFromStorage();

  const cleanedCoursesList = storagedCourses?.filter(
    (course) => course?.slug !== slug,
  );

  saveCoursesInStorage(cleanedCoursesList);
};
